































import Vue from 'vue';
import AceEditor from './editor/ace.vue';
import FieldMapDescription from './fieldMapDescription.vue';
import { mapState, mapMutations } from 'vuex';
import { fetchPointData } from './utils/fetchPointData';
import { excuteScriptCode } from './utils/excuteScriptCode';
import { mapFetchPointParams } from './utils/mapFetchPointParams';
import { DataSource } from './types/interface';
export default Vue.extend({
    data() {
        return {
            originEditorRef: {},

            editorloading: false,

            // 是否开启调试
            isDebug: false,
        }
    },
    components: {
        AceEditor,
        FieldMapDescription
    },
    props: {
        editorWidth: {
            type: String,
            default: '420'
        },
        /**
         * 是否为调试环境
         */
        isTestEnviron: {
           type: Boolean,
           default: true, 
        }
    },
    computed: {
        ...mapState({
            partSelection: (state: any) => state.screen.editor.partSelection,
            // vuex层的数据源
            dataSource: (state: any) => state.screen.editor.dataSource,
        }),
        /**
         * 被选中的part数组
         */
        selectGroup(): Model.Part[] {
            return this.partSelection.selectGroup;
        },
        /**
         * 当前选中的part
         * 目前只处理单个part
         */
        curSelectPart(): Model.Part {
            const { length } = this.selectGroup
            return length === 1 ? this.selectGroup[0] : {}
        },
        // 数据源容器
        partData(): Model.DataSource {
            const partData = this.curSelectPart.partData;
            return partData;
        },
        // 启用过滤器
        useScript(): boolean {
            return (this.partData && this.partData.useScript) || false;
        },
        // 过滤器脚本
        scriptLog(): string {
            return (this.partData && this.partData.scriptLog) || 'return data';
        },
        // 数据源类型
        sourceType(): number {
            return (this.partData && this.partData.sourceType) || 1;
        },
        // 静态数据源
        sourceData(): string {
            return this.partData && this.partData.staticData && this.partData.staticData.sourceData;
        },
        // 测点数据源
        pointData(): Model.PointModel {
            return this.partData && this.partData.pointData;
        },
        // 展示数据的缓存
        displayDataPool: {
            get(): string {
                return this.dataSource &&  this.dataSource.displayData || '[]';
            },
            set(newDisplayData: string): void {
                if (_.isString(newDisplayData)) {
                    this.set_displayData(newDisplayData);
                }
            }
        },
        // 测点请求的缓存数据
        pointReqDataPool: {
            get(): string {
                return this.dataSource &&  this.dataSource.pointReqData || '[]';
            },
            set(newPointReqData: string): void {
                if (_.isString(newPointReqData)) {
                    this.set_pointReqData(newPointReqData);
                }
            }
        },
        drawerStatus() {
            return this.dataSource &&  this.dataSource.drawerStatus || false;
        }
    },
    watch: {
        /**
         * 切换展示数据的
         * 调试环境，不需要更新数据
         */
        curSelectPart() {
            if (this.isTestEnviron) {
                return;
            }
            // 初始化sourceData
            // 如果静态数据模块没有保存上次编辑的数据，就调用获取静态数据
            this.initSourceData();
            this.updateDisplayData(true);
        },
        /**
         * 监听抽屉的开关，展示数据编辑器聚焦
         * 触发条件，抽屉壮状态为开并且在调试环境中
         */
        drawerStatus() {
            this.$nextTick( () => {
                if (!this.drawerStatus || !this.isTestEnviron) {
                    return;
                }
                (this.originEditorRef as any).alignCursors();
            });
        }
    },
    methods: {
        ...mapMutations([
            'set_partData',
            'set_partStaticData',
            'set_displayData',
            'set_pointReqData',
        ]),
        /**
         * 这里有个过滤器，
         * 展示数据不需要监听该方法
         * 如果是异常数据，不需要设置静态数据
         * 如果是数组数据，则会嗲用设置静态数据的方法
         */
        async updateDisplayData(notUpdatePartSD?: boolean) {
            let parseDisplayData: any[];
            let displayData: string;
            let displayDataToArray = [];

			// 如果类型为空，设置为空数据
			if (!this.sourceType) {
				this.displayDataPool = '';
				return;
			}

            // 根据数据源判断不同的数据类型
            type Result = { displayData: string, displayDataToArray: any[] };
			let result: Result;
            switch (this.sourceType) {
                case DataSource.Static:
					result = this.updateStaticData();
                    break;
                case DataSource.Point:
					result = (await this.updatePointData()) as Result;
                    break;
                default:
                    break;
			}
            
            displayData = result.displayData;
            displayDataToArray = result.displayDataToArray;

            // 如果开启过滤器，进入过滤器
            if (this.useScript) {
                displayData = this.filterInScript(displayDataToArray);
            }
            // console.log(displayData);
            // 显示数据模块
            if (this.displayDataPool) {
                // 如果现在的展示数据和获取的数据一致，没必要切换展示数据和设置数据
                const jsonDisplayDataPool = JSON.parse(JSON.stringify(this.displayDataPool));
                if (jsonDisplayDataPool === displayData) {
                    // console.log('相同的展示数据...');
                    return;
                }
            }
            this.displayDataPool = displayData;
            
            // 展示环境，不需要设置数据
            if (!this.isTestEnviron) {
                return;
            }
            
            // 将转化后的数据，编译为数组
            try {
                parseDisplayData = JSON.parse(displayData);
            } catch (error) {
                return;
            }

            // 如果为数组，更新静态数据
            // 是否需要更新数据，应该和上次过滤后的数据做比较，如果是一模一样的，就不需要更新数据
            if (!notUpdatePartSD && parseDisplayData) {
                if (Array.isArray(parseDisplayData)) {
                    this.set_partStaticData(parseDisplayData);
                } else {
                    // this.displayDataPool = '数据必须为数组对象';
                }
            }
        },
        /**
         * 更新静态数据的展示
         */
        updateStaticData(): {displayData: string, displayDataToArray: any[]} {
            // 字符串转为数组
            let displayData: string = '';
            let displayDataToArray: any[] = [];
            if (this.sourceData && _.isString(this.sourceData)) {
                try {
                    displayDataToArray = JSON.parse(this.sourceData);
                    displayData = this.sourceData;
                } catch (error) {
                    displayData = '编辑器输入内容有误';
                }
            }
            return { displayData, displayDataToArray};
        },
        /**
         * 更新测点数据的展示
         */
        updatePointData() {
            // 获取数据，返回一个promise
            return new Promise( (resolve, reject) => {
                console.log('开始 fetch point data');
                let displayData: string;
                let displayDataToArray: any[];

                // 这里需要根据测点模型，请求一遍数据
                this.editorloading = true;
                // 获取请求测点数据的参数
                const getPointParam = mapFetchPointParams(this.pointData);
                // 如果测点列表为空，不请求数据
                if (!getPointParam.pointGroup.length) {
                    resolve({ displayData: '[]', displayDataToArray: []});
                }
                fetchPointData().then(
                    (success: any) => {
                        this.editorloading =false;
                        this.pointReqDataPool = JSON.stringify(success, null, 2);
                        
                        // 字符串转为数组
                        displayData = this.pointReqDataPool || '[]';
                        displayDataToArray = success;
                        resolve({ displayData, displayDataToArray});
                    },
                    (error: any) => {
                        this.editorloading =false;
                        // 将错误提交到告警中心
                        reject();
                    }
                );
            });
        },
        /**
         * 初始化sourceData
         */
        initSourceData() {
            if (!_.isEmpty(this.curSelectPart)) {
                // 如果静态数据模块没有保存上次编辑的数据，就调用获取静态数据
                const hasCacheSourceData = this.sourceData;
                const sourceDataTemp = hasCacheSourceData?
                    hasCacheSourceData:
                    JSON.stringify((this.curSelectPart as any).getPartStaticData(), null, 2);
                // 第一次加载设置展示数据
                this.partData.staticData.sourceData = sourceDataTemp;
            }
        },
        /**
         * 在脚本环境下，过滤数据
         */
        filterInScript(arraySourceData: any[]): string {
            // 获取输入数据, 非字符串的处理
            if (arraySourceData && _.isString(arraySourceData)) {
                arraySourceData = JSON.parse(arraySourceData);
            }
            const inputSourceData: any = _.isEmpty(this.curSelectPart) ? [] : arraySourceData;
            // 输出数据，输入用户代码
            const outpuSourcetData = excuteScriptCode(inputSourceData, this.scriptLog);
            // 输出转化数据
            return JSON.stringify(outpuSourcetData, null, 2);
        },
        /**
         * 监听是否开启调试
         */
        onListenerEditorTest(isDestroyed?: boolean): void {
            if (isDestroyed) {
                (this.$root as any).busRef.$off('changeEditorTest');
                return;
            }
            (this.$root as any).busRef.$on('changeEditorTest', (isDebug: boolean) => {
                this.isDebug = isDebug;
            });
        },
        /**
         * 监听测点发生改变，请求数据
         */
        onListenerFetchPoint(isDestroyed?: boolean): void {
            if (isDestroyed) {
                (this.$root as any).busRef.$off('fetchPoint');
                return;
            }
            (this.$root as any).busRef.$on('fetchPoint', () => {
                // 调试script，显示结果
                if (!this.isTestEnviron) {
                    return;
                }
                // 如果调试状态，不需要请求数据
                if (this.isDebug) {
                    return;
                }
                if (!_.isEmpty(this.curSelectPart)) {
                    this.updateDisplayData();
                }
                
            });
        },
        /**
         * 监听测点发生改变，请求数据
         */
        onListenerStaticData(isDestroyed?: boolean): void {
            if (isDestroyed) {
                (this.$root as any).busRef.$off('fetchStatic');
                return;
            }
            (this.$root as any).busRef.$on('fetchStatic', () => {
                // 调试script，显示结果
                if (!this.isTestEnviron) {
                    return;
                }
                // 如果调试状态，不需要请求数据
                if (this.isDebug) {
                    return;
                }
                if (!_.isEmpty(this.curSelectPart)) {
                    
                    this.updateDisplayData();
                }
            });
        },
        /**
         * 监听抽屉组件的开关状态
         * 重写mixin中的方法
         */
        onListenerScriptChange(isDestroyed?: boolean) {
            if (isDestroyed) {
                (this.$root as any).busRef.$off('scriptChange');
                return;
            }
            (this.$root as any).busRef.$on('scriptChange', (message) => {
                // 调试script，显示结果
                if (!this.isTestEnviron) {
                    return;
                }
                if (!_.isEmpty(this.curSelectPart)) {
                    this.updateDisplayData();
                }
            });
        },
        /**
         * 初始化编辑器的引用
         * @editor 编辑器实例的引用
         */
        onMountedEditor(editor: any) {
            this.originEditorRef = editor;
        },
        refreshData() {
            this.updateDisplayData();
        }
    },
    mounted() {
        // 解决了drawer组件内不渲染数据的问题
        if (!_.isEmpty(this.curSelectPart)) {
            this.updateDisplayData();
        }
        this.onListenerScriptChange();
        this.onListenerEditorTest();
        this.onListenerFetchPoint();
        this.onListenerStaticData();
    },
    beforeDestroy() {
        const isDestroy = true;
        this.originEditorRef = null;
        this.onListenerScriptChange(isDestroy)
        this.onListenerFetchPoint(isDestroy);
        this.onListenerEditorTest(isDestroy);
        this.onListenerStaticData(isDestroy);
    }
})
